"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classnames = _interopRequireDefault(require("classnames"));

var TopicContainer = function TopicContainer(_ref) {
  var anchorProps = _ref.anchorProps,
      infoSlot = _ref.infoSlot,
      children = _ref.children,
      clickCallback = _ref.clickCallback,
      topicInfoWrapperClassName = _ref.topicInfoWrapperClassName;
  return (0, _preact.h)("a", (0, _extends2.default)({}, anchorProps, {
    className: (0, _classnames.default)(anchorProps.className, 'topic-view_anchor'),
    "data-track-type": "click",
    "data-element-name": "Topic title link",
    onClick: function onClick() {
      return clickCallback === null || clickCallback === void 0 ? void 0 : clickCallback();
    },
    role: "button",
    onKeyDown: function onKeyDown(e) {
      return e.key === 'Enter' && (clickCallback === null || clickCallback === void 0 ? void 0 : clickCallback());
    },
    tabIndex: 0
  }), (0, _preact.h)("div", {
    className: topicInfoWrapperClassName !== null && topicInfoWrapperClassName !== void 0 ? topicInfoWrapperClassName : 'topic-view_info add_margin'
  }, infoSlot !== null && infoSlot !== void 0 ? infoSlot : null, (0, _preact.h)("div", {
    className: "topic-view_body-container"
  }, (0, _preact.h)("div", {
    className: "topic-view_body"
  }, children))));
};

var _default = TopicContainer;
exports.default = _default;